// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LsRf","left":"styles_left__1BmyJ","desktopActions":"styles_desktopActions__3UVxR","title":"styles_title__CYOXh"};